import React, { useState } from 'react';
import { Box, Chip, MenuItem, TextField } from '@mui/material';

import { fetchAdminSession } from '../../api/staffAccess';
import { canManageAccess, getAdminToken, getAdminViewAs, saveAdminSession, setAdminViewAs } from '../../utils/adminSession';
import { colour, pillSx } from '../admin/tokens';

/**
 * "View as": for an access manager, to see the staff screens exactly as the enrolment or accounts
 * team does. The choice goes to the server with every request, which then answers as for that team
 * — the same columns, and the same fields left out — so nothing here works out a view of its own.
 */
const LABELS = { enrolment: 'Enrolment team', accounts: 'Accounts team', both: 'Both teams' };

export const reload = () => window.location.reload();

const ViewAsSwitch = ({ onReload = reload }) => {
    const [viewAs, setViewAs] = useState(getAdminViewAs());
    const [busy, setBusy] = useState(false);

    if (!canManageAccess()) return null;

    const change = async (event) => {
        const next = event.target.value;
        setBusy(true);
        setAdminViewAs(next);
        setViewAs(next);
        try {
            // The server says which team this now is; every screen reads it from the session.
            const session = await fetchAdminSession();
            saveAdminSession({ token: getAdminToken(), ...session });
        } catch {
            // The next screen asks again; the header is already set.
        }
        onReload();
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
            {viewAs && <Chip size="small" label={`Viewing as: ${LABELS[viewAs]}`} sx={pillSx('warn')} />}
            <TextField
                select
                size="small"
                label="View as"
                value={viewAs}
                onChange={change}
                disabled={busy}
                sx={{ minWidth: 170, '& .MuiInputBase-root': { fontSize: '13px' } }}
                SelectProps={{ displayEmpty: true }}
                InputLabelProps={{ shrink: true, sx: { color: colour.muted } }}
            >
                <MenuItem value="">My own view</MenuItem>
                <MenuItem value="enrolment">{LABELS.enrolment}</MenuItem>
                <MenuItem value="accounts">{LABELS.accounts}</MenuItem>
                <MenuItem value="both">{LABELS.both}</MenuItem>
            </TextField>
        </Box>
    );
};

export default ViewAsSwitch;
